export default __webpack_public_path__ + "static/media/icn-fingerprint.3555c0d2.svg";